import styles from "./styles.module.css";
import Head from 'next/head';


const FreeHtml = (props) => {
    const { content } = props;
    
    const regexStyle = /<style>([\s\S]*?)<\/style>/;
    const matchStyle = content && content.match(regexStyle);

    const styleContent = matchStyle ? matchStyle[1] : '';
    const contentWithOutStyle = content && content.replace(regexStyle, '');

    return (
        <>
            {content && styleContent && (
                <Head>
                    <style>{styleContent}</style>
                </Head>
            )}
            {content && contentWithOutStyle && (
                <div className={`text-content ${styles['free-html-content']} ${styles["paragraph-detail"]}`} 
                    dangerouslySetInnerHTML={{ __html: contentWithOutStyle }} 
                />
            )}
        </>
    );
};

export default FreeHtml;
